Game.JSON.signposts = {
	'intro': 'Find the Keys and Coins to Escape.',
	'orange-door': 'The Orange key opens the Orange door. Check up top!',
	'philosophy': '[PHILOSOPHY]',
	'fizz-buzz': '1. 2. Fizz. 4. Buzz. Fizz. 7. 8. Fizz. Buzz.',
	'exit': 'Find 200 coins to Exit!',
	'congratulations': 'You did it! You are free!',
	'coin-challenge': 'You found [COINS-FOUND] of [COINS-TOTAL] coins!',
	'secrets': 'Look out for the many secrets.',
};
